import "./styles.scss";

import moment from "moment";
import { useTranslation } from "react-i18next";

import ModalNew from "components/ModalNew";

import { useWebsite } from "context/client/website";

const mainClass = "cancel-plan-modal";

const CancelPlanModal = ({ subscription_end, isOpen, onClose }) => {
  const { t } = useTranslation();
  const { customer_cancel_plan_loading, customerPortal } = useWebsite();

  const onSubmit = async () => {
    try {
      customerPortal("cancel-plan");
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <ModalNew
      title={t("Are you done using Webinity?")}
      loading={customer_cancel_plan_loading}
      labelSubmit={t("Finish cancellation")}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    >
      <div className={mainClass}>
        <h2>
          {t(
            "If you're sure you'd like to cancel your subscription, finish below"
          )}
        </h2>
        <ul>
          <li>
            {t(
              "Cancellation will be effective at the end of your current billing cycle on"
            )}{" "}
            {moment.unix(subscription_end)?.format("ll")}
          </li>
          <li>{t("Come back anytime you like")}</li>
        </ul>
      </div>
    </ModalNew>
  );
};

export default CancelPlanModal;
